import React from "react";
import { Column, ColumnId } from ".";
import base from "./base";
import BuildingCellContent from "../components/BuildingCellContent";

function building({ width, onResize }: Column.Options) {
	return base(
		ColumnId.Building,
		(item) => <BuildingCellContent item={item} />,
		{
			width,

			onResize: onResize as (
				columnWidth?: number | undefined,
				dataKey?: string | undefined,
			) => void,
		},
	);
}

export default building;
